// FiltersByType.jsx

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setJS } from "../../../actions/globalReportFilters";
import FilterDropdown, { transformArrToOptions } from "../../FiltersDropdown";
import { CheckHideBool } from "../CheckHide";

const FiltersByType = ({
    height = "auto",
    hide = [],
    dataBookings: dataBookingsProp,
}) => {
    const js = useSelector((state) => state.globalReportFilters);
    const { id: hotelID } = useSelector((state) => state.hotelID);
    const dataBookingsFromStore = useSelector((state) => state.dataBookings);
    const dataBookings = dataBookingsProp ?? dataBookingsFromStore;
    const dispatch = useDispatch();

    const [activeFilters, setActiveFilters] = useState({
        Countries: [],
        Offers: [],
        Rooms: [],
        Types: [],
        Extras: [],
        VoucherNames: [],
    });

    const [countriesOptions, setCountriesOptions] = useState([]);
    const [offersOptions, setOffersOptions] = useState([]);
    const [roomsOptions, setRoomsOptions] = useState([]);
    const [typesOptions, setTypesOptions] = useState([]);
    const [extrasOptions, setExtrasOptions] = useState([]);
    const [vouchersNamesOptions, setVouchersNamesOptions] = useState([]);

    useEffect(() => {
        if (
            dataBookings.status !== "loaded" &&
            dataBookings.status !== "partiallyLoaded"
        )
            return;

        const countrySet = new Set();
        const offerSet = new Set();
        const roomSet = new Set();
        const typeSet = new Set();
        const extraSet = new Set();
        const voucherNamesSet = new Set();

        dataBookings.data.forEach((e) => {
            if (e.Country && e.Country.trim() !== "") countrySet.add(e.Country);
            if (e.OfferTitle && e.OfferTitle.trim() !== "")
                offerSet.add(e.OfferTitle);
            if (e.RoomName && e.RoomName.trim() !== "") roomSet.add(e.RoomName);
            if (e.Type && e.Type.trim() !== "") typeSet.add(e.Type);
            if (e.VoucherName && e.VoucherName.trim() !== "")
                voucherNamesSet.add(e.VoucherName);

            if ((e.Extras ?? []).length > 0) {
                (e.Extras ?? []).forEach((extra) => {
                    extraSet.add(extra.Description);
                });
            }
        });

        setCountriesOptions([...countrySet].sort());
        setOffersOptions([...offerSet].sort());
        setRoomsOptions([...roomSet].sort());
        setTypesOptions([...typeSet].sort());
        setExtrasOptions([...extraSet].sort());
        setVouchersNamesOptions([...voucherNamesSet].sort());
    }, [dataBookings]);

    useEffect(() => {
        let auxActiveFilters = {
            Countries: (js.filters ?? {}).Countries ?? [],
            Offers: (js.filters ?? {}).Offers ?? [],
            Rooms: (js.filters ?? {}).Rooms ?? [],
            Types: (js.filters ?? {}).Types ?? [],
            Extras: (js.filters ?? {}).Extras ?? [],
            VoucherNames: (js.filters ?? {}).VoucherNames ?? [],
        };

        setActiveFilters(auxActiveFilters);
    }, [js]);

    return (
        <>
            <FilterDropdown
                title="Filters"
                buttonProps={{ sx: { height: height } }}
                activeFilters={activeFilters}
                setActiveFilters={(activeFilters) => {
                    let newJS = {
                        ...js,
                        filters: { ...(js.filters ?? {}), ...activeFilters },
                    };

                    dispatch(setJS(newJS));
                }}
                filters={{
                    ...(hide.includes("FILTERS_COUNTRIES")
                        ? {}
                        : {
                              Countries: {
                                  label: "Country",
                                  options:
                                      transformArrToOptions(countriesOptions),
                              },
                          }),
                    ...(hide.includes("FILTERS_OFFERS")
                        ? {}
                        : {
                              Offers: {
                                  label: "Rate plans",
                                  options: transformArrToOptions(offersOptions),
                              },
                          }),
                    ...(hide.includes("FILTERS_ROOMS")
                        ? {}
                        : {
                              Rooms: {
                                  label: "Rooms",
                                  options: transformArrToOptions(roomsOptions),
                              },
                          }),
                    ...(hide.includes("FILTERS_TYPES")
                        ? {}
                        : {
                              Types: {
                                  label: "Types",
                                  options: transformArrToOptions(typesOptions),
                              },
                          }),
                    ...(hide.includes("FILTERS_EXTRAS")
                        ? {}
                        : {
                              Extras: {
                                  label: "Extras",
                                  options: transformArrToOptions(extrasOptions),
                              },
                          }),
                    //Types: {
                    //    label: "Types",
                    //    options: transformArrToOptions(typesOptions),
                    //},
                    ...(hide.includes("FILTERS_VOUCHERS")
                        ? {}
                        : CheckHideBool("Vouchers", hotelID) && {
                              VoucherNames: {
                                  label: "Vouchers",
                                  options:
                                      transformArrToOptions(
                                          vouchersNamesOptions,
                                      ),
                              },
                          }),
                }}
            />
        </>
    );
};

export default FiltersByType;
